import { makeAutoObservable } from 'mobx';
import { InvestownMonthlyStatusDto } from '../../../../defs/api';

export class InvestownMonthlyStatusMobxDto implements InvestownMonthlyStatusDto {
    month: string;

    invested: number;

    interestYield: number;

    rewards: number;

    fees: number;

    profit: number;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: InvestownMonthlyStatusDto): InvestownMonthlyStatusMobxDto {
        const mobxDto = new InvestownMonthlyStatusMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: InvestownMonthlyStatusDto[]): InvestownMonthlyStatusMobxDto[] {
        return dtos.map((dto) => InvestownMonthlyStatusMobxDto.create(dto));
    }
}
